<script setup lang="ts">

import {useDate} from "@/composables/date";
import {Token, User} from "@/types";
import DeleteTokenDialog from "@/Pages/settings/authentication/components/DeleteTokenDialog.vue";
import CopyBtn from "@/components/buttons/CopyBtn.vue";

interface Props {
    user: User,
    tokens: Array<Token>,
    temporaryToken?: string
}
const props = defineProps<Props>()
const { shortDate, lastUsed } = useDate()
</script>

<template>
    <v-list
        v-if="tokens.length > 0 || props.temporaryToken"
        density="compact"
        class="border mt-3 py-0"
        rounded="lg"
    >
        <v-list-item
            v-if="props.temporaryToken"
            class="bg-green-lighten-5 py-3 border-b"
        >
            <template #prepend>
                <v-icon
                    size="small"
                    color="green"
                >
                    mdi-check
                </v-icon>
            </template>
            <code
                id="copy-btn"
                class="text-grey-darken-3"
            >{{ props.temporaryToken }}</code>
            <copy-btn :text="props.temporaryToken" />
        </v-list-item>
        <v-list-item
            v-for="token in tokens"
            :key="token.id"
            class="border-b py-2 px-3"
        >
            <v-list-item-title class="text-body-2 font-weight-regular">
                <b>{{ token.name }}</b> — <i
                    class="text-caption text-grey-darken-1"
                >{{ token.abilities.toString() }}</i>
            </v-list-item-title>
            <div
                v-if="token.expires_at"
                class="text-caption black--text font-weight-regular"
            >
                Expires <i>on {{ shortDate(token.expires_at) }}</i>
            </div>
            <div
                v-if="!token.expires_at"
                class="text-decoration-none text-caption font-weight-regular amber--text"
            >
                <v-icon
                    small
                    left
                    color="amber"
                >
                    mdi-alert-outline
                </v-icon>
                This token has no expiration date.
            </div>
            <template #append>
                <v-list-item-action>
                    <small
                        v-if="token.last_used_at"
                        class="text-grey-darken-1 mr-5"
                    >Last used
                        {{ lastUsed(token.last_used_at) }}</small>
                    <small
                        v-if="!token.last_used_at"
                        class="text-grey-darken-1 mr-5"
                    >Never used</small>
                    <delete-token-dialog
                        :user="props.user"
                        :token="token"
                    />
                </v-list-item-action>
            </template>
        </v-list-item>
    </v-list>
</template>

<style scoped>

</style>
